// extracted by mini-css-extract-plugin
module.exports = {"gothamrounded":"a"};